import type { FC } from 'react';
import React from 'react';
import { Box } from '@mui/material';

import { styles } from './index.styles';

interface InlineErrorMessageProps {
  error?: string | string[] | Record<string, unknown> | null;
}

const InlineErrorMessage: FC<InlineErrorMessageProps> = ({ error }) => {
  if (!error) {
    return null;
  }

  if (Array.isArray(error)) {
    return (
      <>
        {error.map((msg, i) => (
          <Box sx={styles.error} key={i}>
            {String(msg)}
          </Box>
        ))}
      </>
    );
  }

  if (typeof error === 'object') {
    return (
      <>
        {Object.entries(error).map(([key, value], i) => (
          <Box sx={styles.error} key={i}>
            {`${key}: ${JSON.stringify(value)}`}
          </Box>
        ))}
      </>
    );
  }

  return <Box sx={styles.error}>{String(error)}</Box>;
};

export default InlineErrorMessage;
